import { useEffect, useState } from "react";
import { Pagination, PaginationSectionWrapper } from "../../../components/Pagination";
import { Loading } from "../../../components/ui/loading";
import { ResourceLoadingError } from "../../../components/ui/resource-loading-error";
import Workspace from "../../../components/workspace";
import roleService from "../../../services/role-service";
import Roles from "./Roles";

const RoleListContainer = ({ searchQuery = "" }) => {
   const [isLoading, setIsLoading] = useState(true);
   const [errorMessage, setErrorMessage] = useState();
   const [roles, setRoles] = useState([]);
   const [totalPages, setTotalPages] = useState(1);
   const [page, setPage] = useState(1);
   const [rows] = useState(10);

   useEffect(() => {
      const loadRoles = async () => {
         setIsLoading(true);
         try {
            const fetchResult = await roleService.getRoles({ page, rows, searchQuery });
            setRoles(fetchResult.data);
            setTotalPages(fetchResult.totalPages);
         } catch (error) {
            setErrorMessage(error.message);
         } finally {
            setIsLoading(false);
         }
      };

      loadRoles();

      return () => {};
   }, [page, rows, searchQuery]);

   if (isLoading) return <Loading />;
   if (errorMessage) return <ResourceLoadingError error={errorMessage} />;

   return (
      <Workspace.List>
         <Roles roles={roles} />
         <PaginationSectionWrapper>
            {roles.length ? <Pagination setPage={setPage} page={page} totalPages={totalPages} /> : ""}
         </PaginationSectionWrapper>
      </Workspace.List>
   );
};

export default RoleListContainer;
